import { render, staticRenderFns } from "./weight.vue?vue&type=template&id=d6beec42&scoped=true"
import script from "./weight.vue?vue&type=script&lang=js"
export * from "./weight.vue?vue&type=script&lang=js"
import style0 from "./weight.vue?vue&type=style&index=0&id=d6beec42&lang=css"
import style1 from "./weight.vue?vue&type=style&index=1&id=d6beec42&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6beec42",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Prod-平台矩阵/platform-miniprogram-cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d6beec42')) {
      api.createRecord('d6beec42', component.options)
    } else {
      api.reload('d6beec42', component.options)
    }
    module.hot.accept("./weight.vue?vue&type=template&id=d6beec42&scoped=true", function () {
      api.rerender('d6beec42', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/shopManagement/components/weight.vue"
export default component.exports